<script lang="ts" setup>
import LiftPlanUE from '@/components/common/projects/lift-plan-ue/LiftPlanUE.vue';
import { PhCircleNotch, PhPlus } from '@phosphor-icons/vue';
import { useI18n } from 'vue-i18n';
import {
  useLiftPlanUEListLogic,
  type LiftPlanUEListEmit,
  type UseLiftPlanUEListLogicProps,
} from './logic/useLiftPlanUEListLogic';

export type LiftPlanUEListProps = UseLiftPlanUEListLogicProps;
const props = defineProps<LiftPlanUEListProps>();
const emit = defineEmits<LiftPlanUEListEmit>();
const { state, action } = useLiftPlanUEListLogic(props, emit);
const { t } = useI18n();
</script>

<template>
  <div class="lift-plan-ue">
    <div v-for="plan in state.liftPlans" :key="plan.id" class="ue-plan-wrapper">
      <LiftPlanUE v-bind="plan" />
    </div>

    <button
      class="add-ue-btn"
      :disabled="props.isCreating"
      @click="action.addUE()"
      v-if="state.mode.addUEButton === 'visible'"
    >
      <PhCircleNotch v-if="props.isCreating" :size="16" class="spin" />
      <PhPlus v-else :size="16" />
      {{ t('projects.liftPlanUE.list.addButton') }}
    </button>
  </div>
</template>

<style scoped>
.lift-plan-ue {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.ue-plan-wrapper {
  display: flex;
  flex-direction: column;
}

.add-ue-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  background: none;
  border: 2px dashed var(--primary-color);
  border-radius: 6px;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 0.875rem;
  transition: opacity 0.15s;
}

.add-ue-btn:hover {
  opacity: 0.65;
}

.add-ue-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.spin {
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
